import styled from 'styled-components'

export const Text = styled.div`
  color: var(--black);
  font-size: 1.5rem;
  font-weight: 400;
`
